export default __webpack_public_path__ + "static/media/bg6.64d7ac30.jpg";